import { render } from "./Campos.vue?vue&type=template&id=b07351be&scoped=true"
import script from "./Campos.vue?vue&type=script&lang=js"
export * from "./Campos.vue?vue&type=script&lang=js"

import "./Campos.vue?vue&type=style&index=0&id=b07351be&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b07351be"]])

export default __exports__